import React, { useEffect, useState } from 'react';
import { Modal } from 'reactstrap';

import { PredefinedMilisecondsTypeEnum } from '../../../../lib/enums';
import lang from '../../../../lib/language';
import { useTimeout } from '../../../../lib/util/hooks/TimeoutHooks';

import iconSuccess from '../../../../assets/img/check-circle_24px.png';
import iconError from '../../../../assets/img/icon_order_rejected.svg';
import { useIsMobile } from '../../../../hooks';

import styles from './InternalTransferModal.module.scss';

export type Props = {
  isSuccessful: boolean
  amount: number | string
  onClose: () => void
};

const InternalTransferModal = (props: Props) => {
  const {
    isSuccessful,
    amount,
    onClose,
  } = props;

  const isMobile = useIsMobile();

  const [isOpen, setIsOpen] = useState<boolean>(true);

  useTimeout(
    () => {
      setIsOpen(false);
      onClose();
    },
    PredefinedMilisecondsTypeEnum.fiveSeconds,
    'internalTransferModal',
  );

  const handleWrapperContent = (icon: string, text: string) => (
    <div className={styles.content}>
      <img className={styles.icon} src={icon} alt="icon card transfer" />
      <div className={styles.descriptionBox}>
        <h6 className={styles.description}>{text}</h6>
      </div>
    </div>
  );

  return (
    <>
      {isMobile ? (
        <>
          { isOpen && (
            <div className={styles.popupWrapper}>
              <div className={styles.container}>
                { isSuccessful
                  ? handleWrapperContent(iconSuccess, lang.internalTransferSuccessModalText(amount.toString()))
                  : handleWrapperContent(iconError, lang.mobileFundsScreenFailedCardDepositDialog())}
              </div>
            </div>
          )}
        </>
      ) : (
        <Modal
          centered
          isOpen={isOpen}
          contentClassName={styles.modal}
        >
          <div className={styles.wrapperContent}>
            { isSuccessful
              ? handleWrapperContent(iconSuccess, lang.internalTransferSuccessModalText(amount.toString()))
              : handleWrapperContent(iconError, lang.mobileFundsScreenFailedCardDepositDialog())}
          </div>
        </Modal>
      )}
    </>
  );
};

export default InternalTransferModal;
